var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nftInfo"
  }, [_c('div', {
    staticClass: "nftInfo-body"
  }, [_c('div', {
    staticClass: "nftInfo-main"
  }, [_c('div', {
    staticClass: "nftInfo-banner",
    style: {
      background: `url(${require('@images/tapcoin/new/nftInfo/nftInfo-banner.jpg')}) center top/100% auto no-repeat`
    }
  }, [_vm._m(0)]), _c('div', {
    staticClass: "nftInfo-items"
  }, [_vm._m(1), _c('div', {
    staticClass: "nftInfo-items-main",
    style: {
      background: `url(${require('@images/tapcoin/new/nftInfo/nftInfo-items-bg.png')}) center top/100% auto no-repeat`
    }
  }, [_c('div', {
    staticClass: "nftInfo-items-item a"
  }, [_c('div', {
    staticClass: "nftInfo-items-item-main",
    class: _vm.devicePixelRatio > 1.5 && 'dep'
  }, [_c('div', {
    staticClass: "nftInfo-items-item__title"
  }, [_vm._v("COLLECTIBLE")]), _c('div', {
    staticClass: "nftInfo-items-item__label"
  }, [_vm._v("Each MetaCat has a unique rarity level—the rarer, the more valuable!")])])]), _c('div', {
    staticClass: "nftInfo-items-item b"
  }, [_c('div', {
    staticClass: "nftInfo-items-item-main",
    class: _vm.devicePixelRatio > 1.5 && 'dep'
  }, [_c('div', {
    staticClass: "nftInfo-items-item__title"
  }, [_vm._v("TRADABLE")]), _c('div', {
    staticClass: "nftInfo-items-item__label"
  }, [_vm._v("MetaCats NFT will soon be freely traded on exchanges.")])])]), _c('div', {
    staticClass: "nftInfo-items-item c"
  }, [_c('div', {
    staticClass: "nftInfo-items-item-main",
    class: _vm.devicePixelRatio > 1.5 && 'dep'
  }, [_c('div', {
    staticClass: "nftInfo-items-item__title"
  }, [_vm._v("CRAFTABLE")]), _c('div', {
    staticClass: "nftInfo-items-item__label"
  }, [_vm._v("10 NFT Shards can be combined into one MetaCats NFT.")])])]), _c('div', {
    staticClass: "nftInfo-items-item d"
  }, [_c('div', {
    staticClass: "nftInfo-items-item-main",
    class: _vm.devicePixelRatio > 1.5 && 'dep'
  }, [_c('div', {
    staticClass: "nftInfo-items-item__title"
  }, [_vm._v("PROFITABLE")]), _c('div', {
    staticClass: "nftInfo-items-item__label"
  }, [_vm._v("Hold different types of NFTs to earn a share of TapCoins’ project revenue.")])])])])]), _c('div', {
    staticClass: "nftInfo-footer",
    style: {
      background: `url(${require('@images/tapcoin/new/nftInfo/nftInfo-footer.jpg')}) center top/100% auto no-repeat`
    }
  }, [_vm._m(2)])])])]);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nftInfo-banner-main"
  }, [_c('div', {
    staticClass: "nftInfo-banner__title"
  }, [_vm._v("What is MetaCats?")]), _c('div', {
    staticClass: "nftInfo-banner__intro"
  }, [_vm._v("MetaCats are TapCoins’ official NFT series."), _c('br'), _vm._v("They’re your ticket to unlock more rewards and perks within the TapCoins.")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nftInfo-items__title"
  }, [_c('span', [_vm._v("METACATS NFT INFO")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "nftInfo-footer-main"
  }, [_c('div', {
    staticClass: "nftInfo-footer__title"
  }, [_vm._v("More NFT magic is on the way...")]), _c('div', {
    staticClass: "nftInfo-footer__label"
  }, [_vm._v(" Collect clues"), _c('br'), _vm._v(" awaken the sleeping MetaCat ")])]);
}];
export { render, staticRenderFns };